/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

// Do Not change this config
export const DEFAULT_APP_CONFIG = {
  servers: {
    graphql: [
      {
        name: "graphql-gateway",
        // url: "https://gem-be.vlinderserver.online/core/gql/", // Staging Server
        // url: "https://kiran.vlinderserver.online/gem/tenant/core/", // Dev Server
        url: "https://ca-central-gem-01.vlinder.io/pure/core/", // Pure Production Server,
      },
    ],
    rest: {
      loginServer: {
        // baseURL: "https://gem-be.vlinderserver.online/login/", // Staging Server
        // baseURL: "https://kiran.vlinderserver.online/gem/tenant/login/", // Dev Server
        baseURL: "https://ca-central-gem-01.vlinder.io/pure/login/", // Pure Production Server,
      },
    },
  },
  defaultLoading: {
    image:
      "https://s3.ca-central-1.amazonaws.com/io.vlinder.gem-prod/logo/pure.png",
    titleNormalText: "Loading",
    titleBoldText: "Page...",
    description: "This might take a few seconds, Please wait !",
  },
  platformSemantics: {
    semantics: {
      holder: "",
      holders: "",
      issuer: "",
    },
    Holders: {
      title: "",
    },
    HoldersGroups: {
      title: " ",
    },
    DashboardIssuerAnalysis: {
      title: "",
    },
  },
};